module.exports = __webpack_public_path__ + "static/img/u2.6ec544d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/campDetail/u2.jpg
// module id = xCHc
// module chunks = 0